import { __ } from '@bart.sk-eshop/react-i18n';

export const SORT = [
  {
    name: __('Podľa obľúbenosti'),
    sort: 'sale_count',
    sortDir: 'desc',
  },
  {
    name: __('Podľa relevancie'),
    sort: 'relevance',
    sortDir: 'asc',
  },
  {
    name: __('Od najlacnejšieho'),
    sort: 'price',
    sortDir: 'asc',
  },
  {
    name: __('Od najdrahšieho'),
    sort: 'price',
    sortDir: 'desc',
  },
  /*
  {
    name: __('Podľa abecedy A-Z'),
    sort: 'alphabetically',
    sortDir: 'asc',
  },
  {
    name: __('Podľa abecedy Z-A'),
    sort: 'alphabetically',
    sortDir: 'desc',
  },
  */
];

export const SORT_CATEGORY = [
  {
    name: __('Podľa obľúbenosti'),
    sort: 'favorite_sale_count',
    sortDir: 'desc',
  },
  {
    name: __('Od najlacnejšieho'),
    sort: 'price',
    sortDir: 'asc',
  },
  {
    name: __('Od najdrahšieho'),
    sort: 'price',
    sortDir: 'desc',
  },
  /*
  {
    name: __('Podľa abecedy A-Z'),
    sort: 'alphabetically',
    sortDir: 'asc',
  },
  {
    name: __('Podľa abecedy Z-A'),
    sort: 'alphabetically',
    sortDir: 'desc',
  },
  */
];

export const SORT_ACTION = [
  {
    name: __('Od najnovších'),
    sort: 'oldprice_created_at',
    sortDir: 'desc',
  },
].concat(SORT_CATEGORY);

export const DEFAULT_FILTER_TYPES = {
  filterTypes: [
    { name: 'page', urlName: 'page', defaultValue: '1' },
    { name: 'sort', urlName: 'sort', defaultValue: 'favorite_sale_count' },
    { name: 'sortDir', urlName: 'sort-dir', defaultValue: 'desc' },
    { name: 'q', urlName: 'q', defaultValue: '' },
    { name: 'parameters', urlName: 'parameters', defaultValue: '' },
    { name: 'priceMin', urlName: 'price-min', defaultValue: '' },
    { name: 'priceMax', urlName: 'price-max', defaultValue: '' },
    { name: 'flags', urlName: 'flags', defaultValue: '' },
    { name: 'deliveryDays', urlName: 'delivery-days', defaultValue: '' },
  ],
};

export const ACTION_DEFAULT_FILTER_TYPES = {
  filterTypes: [
    { name: 'page', urlName: 'page', defaultValue: '1' },
    { name: 'sort', urlName: 'sort', defaultValue: 'oldprice_created_at' },
    { name: 'sortDir', urlName: 'sort-dir', defaultValue: 'desc' },
    { name: 'q', urlName: 'q', defaultValue: '' },
    { name: 'parameters', urlName: 'parameters', defaultValue: '' },
    { name: 'priceMin', urlName: 'price-min', defaultValue: '' },
    { name: 'priceMax', urlName: 'price-max', defaultValue: '' },
    { name: 'flags', urlName: 'flags', defaultValue: '' },
    { name: 'deliveryDays', urlName: 'delivery-days', defaultValue: '' },
  ],
};

export const MOST_PURCHASED_DEFAULT_FILTER_TYPES = {
  filterTypes: [
    { name: 'page', urlName: 'page', defaultValue: '1' },
    { name: 'sort', urlName: 'sort', defaultValue: 'favorite_sale_count' },
    { name: 'sortDir', urlName: 'sort-dir', defaultValue: 'desc' },
    { name: 'q', urlName: 'q', defaultValue: '' },
  ],
};

export const DEFAULT_PRODUCT_FILTER_TYPES_SEARCH = {
  filterTypes: [
    { name: 'page', urlName: 'page', defaultValue: '1' },
    { name: 'sort', urlName: 'sort', defaultValue: 'sale_count' },
    { name: 'sortDir', urlName: 'sort-dir', defaultValue: 'desc' },
    { name: 'q', urlName: 'q', defaultValue: '', isImmutable: true },
    { name: 'section', urlName: 'section', defaultValue: '0' },
  ],
};

export const DEFAULT_WEBCONTENT_FILTER_TYPES_SEARCH = {
  filterTypes: [
    { name: 'page', urlName: 'page', defaultValue: '1' },
    { name: 'q', urlName: 'q', defaultValue: '', isImmutable: true },
    { name: 'section', urlName: 'section', defaultValue: '1' },
  ],
};

export const DEFAULT_DEMAND_PRODUCT_FILTER_TYPES_SEARCH = {
  filterTypes: [
    { name: 'page', urlName: 'page', defaultValue: '1' },
    { name: 'sort', urlName: 'sort', defaultValue: 'sale_count' },
    { name: 'sortDir', urlName: 'sort-dir', defaultValue: 'desc' },
    { name: 'q', urlName: 'q', defaultValue: '', isImmutable: true },
    { name: 'section', urlName: 'section', defaultValue: '2' },
  ],
};

export const onSortChangeDefault = (addFilter, clickedSort, clickedSortDir) => {
  addFilter({ name: 'page', value: '1' });
  addFilter({ name: 'sort', value: clickedSort });
  addFilter({ name: 'sortDir', value: clickedSortDir });
};

export const onPageChangeDefault = (addFilter, page) => {
  addFilter({ name: 'page', value: String(page) });
};

export const defaultSearchParameters = (filters, limit) => {
  const offset =
    (parseInt(filters.page, 10) - 1) * limit
      ? (parseInt(filters.page, 10) - 1) * limit
      : 0;

  let parameters: any = {
    availabilityId: 1,
    q: filters.q,
    limit,
    offset,
    withAttribs: '1',
    withPublish: 1,
  };

  if (filters.sort !== 'relevance') {
    parameters = {
      ...parameters,
      sort: filters.sort,
      sortDir: filters.sortDir,
    };
  }

  // Attrib filter parameters (comma-separated string → array)
  if (filters.parameters) {
    parameters.parameters = filters.parameters.split(',');
  }

  if (filters.priceMin) {
    parameters.priceMin = filters.priceMin;
  }
  if (filters.priceMax) {
    parameters.priceMax = filters.priceMax;
  }

  if (filters.deliveryDays) {
    parameters.deliveryDays = filters.deliveryDays.split(',');
  }

  if (filters.flags) {
    const flags = filters.flags.split(',');
    if (flags.includes('sale')) parameters.isSale = 1;
    if (flags.includes('new')) parameters.isNewActive = 1;
    if (flags.includes('saleout')) parameters.isSaleout = 1;
    if (flags.includes('top')) parameters.isTop = 1;
  }

  return parameters;
};
